import { render, staticRenderFns } from "./PermissionNode.vue?vue&type=template&id=424ef8fc&scoped=true"
import script from "./PermissionNode.vue?vue&type=script&setup=true&name=PermissionNode&lang=js"
export * from "./PermissionNode.vue?vue&type=script&setup=true&name=PermissionNode&lang=js"
import style0 from "./PermissionNode.vue?vue&type=style&index=0&id=424ef8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424ef8fc",
  null
  
)

export default component.exports